import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { CommonUtilityLib, FilterObject } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';

@Component({
  selector: 'sp-custom-table-filter-menu',
  templateUrl: './custom-table-filter-menu.component.html',
  styleUrls: ['./custom-table-filter-menu.component.scss'],
})
export class CustomTableFilterMenuComponent implements OnInit {
  @ViewChild(MatMenuTrigger) menu!: MatMenuTrigger;
  form!: UntypedFormGroup;

  // filter options to display
  @Input() filterObjects: FilterObject[] = [];

  // on apply event
  @Output() applyFilter = new EventEmitter<AnyType>();

  constructor(private fb: UntypedFormBuilder, private commonUtilityLib: CommonUtilityLib) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  /* Initializing the form */
  initializeForm(): void {
    this.form = this.fb.group({});
    this.addFormControls();
  }

  /* Adding the form controls dynamically based on FilterObject
   array received from parent component */
  addFormControls(): void {
    this.filterObjects.forEach((filterObj: FilterObject) => {
      this.form.addControl(filterObj.name, new UntypedFormControl(filterObj.defaultValue));
    });
  }

  /* Resetting the form controls with default values */
  onReset(event: AnyType): void {
    event.stopPropagation();
    this.applyFilter.emit();
    this.filterObjects.forEach((filterObj: FilterObject) => {
      this.form.controls[filterObj.name].setValue(filterObj.defaultValue);
    });
    this.menu.closeMenu();
  }

  /* Apply filters event */
  apply(): void {
    this.applyFilter.emit(this.form.getRawValue());
    this.menu.closeMenu();
  }
  /**
   * Remove chip from multi select
   * @param value
   */
  removeChip(event: AnyType) {
    const formControlValue = this.form.get(event.formControlName)?.value;
    const modifiedFormControl = this.commonUtilityLib.removeObjectFromArray(formControlValue, event.list.id);
    this.form.get(event.formControlName)?.patchValue(modifiedFormControl);
  }
}
